module.exports = __webpack_public_path__ + "static/media/book8_sportkampioen.a41dcdd6.png";